const ALLOWED_TAGS = new Set([
  'P',
  'BR',
  'B',
  'STRONG',
  'I',
  'EM',
  'U',
  'UL',
  'OL',
  'LI',
  'DIV',
  'SPAN',
]);

function unwrap(el: Element): void {
  const parent = el.parentNode;
  if (!parent) return;
  while (el.firstChild) parent.insertBefore(el.firstChild, el);
  parent.removeChild(el);
}

/** Strip attributes and unwrap disallowed tags (admin template copy only). */
export function sanitizeInvoiceTemplateHtml(input: string): string {
  const trimmed = input.trim();
  if (!trimmed) return '';

  const doc = new DOMParser().parseFromString(`<div id="inv-root">${input}</div>`, 'text/html');
  const root = doc.getElementById('inv-root');
  if (!root) return escapeHtml(input);

  let guard = 0;
  while (guard++ < 500) {
    const elements = Array.from(root.querySelectorAll('*')).reverse();
    let changed = false;
    for (const el of elements) {
      const tag = el.tagName.toUpperCase();
      if (!ALLOWED_TAGS.has(tag)) {
        unwrap(el);
        changed = true;
        break;
      }
      for (const attr of Array.from(el.attributes)) {
        el.removeAttribute(attr.name);
      }
    }
    if (!changed) break;
  }

  return root.innerHTML.trim();
}

export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/** Thank-you / pay body: plain lines → br; already HTML → sanitize */
export function fragmentToSafeHtml(fragment: string): string {
  const t = fragment.trim();
  if (!t) return '';
  if (t.includes('<')) return sanitizeInvoiceTemplateHtml(t);
  return escapeHtml(t).replace(/\n/g, '<br/>');
}

export function payToBlockSafeHtml(cfg: {
  pay_to_heading: string;
  pay_to_content: string;
}): string {
  const h = cfg.pay_to_heading?.trim() || '';
  const body = cfg.pay_to_content?.trim() || '';
  const bodyHtml = body ? fragmentToSafeHtml(body) : '';
  const hHtml = h ? escapeHtml(h) : '';
  if (!hHtml && !bodyHtml) return '';
  if (hHtml && bodyHtml) {
    return `<p style="font-weight:600;margin:0 0 0.35em 0">${hHtml}</p><div>${bodyHtml}</div>`;
  }
  if (hHtml) return `<p style="font-weight:600;margin:0">${hHtml}</p>`;
  return `<div>${bodyHtml}</div>`;
}
